<template>
    <div>
<!-- What is reviewed -->
        <v-row class="mt-0" align="center">
            <v-col cols="12" class="pb-0 d-flex align-center flex-wrap" :alvqa="alvqa + '-schedule'">
                <BaseIcon
                    icon="arrow_back"
                    tooltipText="lang_GENERIC_CAPTION_BACK_TO_LIST"
                    :alvqa="alvqa + '-icon-back'"
                    @click="$router.push({ name: 'Usage' })"
                />
                <template v-if="schedule">
                    <span class="title ml-2">{{ schedule.description || schedule.fileName }}</span>
                    <span class="ml-3 subtitleGray--text">{{ schedule.period.label }}</span>
                    <span v-if="comparison" class="ml-3 subtitleGray--text">
                        · {{ $t('lang_PUBLISHING_USAGE_CAPTION_REVIEW_COMPARED', {
                            at: comparison.comparedAt ? $d(toDate(comparison.comparedAt), 'alvDateTime') : '–',
                            against: statements
                        }) }}
                    </span>
                </template>
            </v-col>
        </v-row>

<!-- Counts: a click filters the list -->
        <v-row v-if="comparison && comparison.counts" class="mt-0">
            <v-col cols="12" class="pb-0">
                <OutcomeCounts
                    :outcomes="comparison.counts.byOutcome"
                    clickable
                    :active="activeOutcome"
                    :alvqa="alvqa"
                    @select="filterOutcome"
                />
                <span class="body-2 subtitleGray--text" :alvqa="alvqa + '-decision-counts'">
                    {{ $t('lang_PUBLISHING_USAGE_CAPTION_REVIEW_DECISION_COUNTS', {
                        undecided: $n(comparison.counts.byDecision.undecided || 0),
                        accepted: $n(comparison.counts.byDecision.accepted || 0),
                        rejected: $n(comparison.counts.byDecision.rejected || 0),
                        claimed: $n(comparison.counts.claimed || 0),
                        exported: $n(comparison.counts.exported || 0)
                    }) }}
                </span>
            </v-col>
        </v-row>

        <v-row>
            <ActionDropdown
                :items="actions"
                context="UsageReview"
                :alvqa="alvqa"
                cols="3"
            />
            <v-col cols="3" class="d-flex align-center">
                <BaseButton
                    label="lang_PUBLISHING_USAGE_BUTTON_EXPORT_COMPLAINTS"
                    icon="file_download"
                    :alvqa="alvqa + '-button-export'"
                    @click="$store.commit('setShowComplaintExportDialog', true)"
                />
            </v-col>
            <v-col cols="4" align-self="center" class="v-label theme--light mt-3">
                <BaseHeaderStats context="UsageReview" typeStats="LIST" :alvqa="alvqa + '-list'" />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'
import OutcomeCounts from '../_components/OutcomeCounts'

export default {
    name: 'UsageReviewTopSlot',
    components: { ActionDropdown, BaseHeaderStats, BaseButton, BaseIcon, OutcomeCounts },
    data() {
        return { alvqa: 'publishing-usage-review' }
    },
    computed: {
        schedule() { return this.$store.getters.getUsageReviewSchedule },
        comparison() { return this.$store.getters.getUsageReviewComparison },
        statements() {
            const c = this.schedule && this.schedule.comparison
            return c && c.statements ? c.statements.map(s => s.description || s.fileName).join(', ') : '–'
        },
        activeOutcome() {
            const outcomes = this.$store.getters.getSelectedUsageReviewOutcomeFilter
            return outcomes.length === 1 ? outcomes[0] : null
        },
        actions() {
            const action = (value, text) => ({ value, text: this.$t(text), alvqa: this.alvqa + '-list-action-dropdown-' + value })
            return [
                action('acceptSelected', 'lang_PUBLISHING_USAGE_ACTION_REVIEW_ACCEPT_SELECTED'),
                action('rejectSelected', 'lang_PUBLISHING_USAGE_ACTION_REVIEW_REJECT_SELECTED'),
                action('undecideSelected', 'lang_PUBLISHING_USAGE_ACTION_REVIEW_UNDECIDE_SELECTED'),
                action('acceptFiltered', 'lang_PUBLISHING_USAGE_ACTION_REVIEW_ACCEPT_FILTERED'),
                action('rejectFiltered', 'lang_PUBLISHING_USAGE_ACTION_REVIEW_REJECT_FILTERED'),
                action('export', 'lang_PUBLISHING_USAGE_BUTTON_EXPORT_COMPLAINTS')
            ]
        }
    },
    methods: {
        toDate(value) { return new Date(String(value).replace(' ', 'T')) },
        filterOutcome(outcome) {
            this.$store.commit('setSelectedUsageReviewOutcomeFilter', this.activeOutcome === outcome ? [] : [outcome])
            this.$store.commit('setCurrentPage', 1)
            this.$store.commit('setSelectedUsageReview', [])
            this.$store.commit('setExpandedUsageReview', [])
            this.$store.dispatch('fetchUsageReview')
        }
    }
}
</script>
